var app = angular.module('leonardo');

var AccountSelector = function(AccountService, $rootScope) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    templateUrl: 'views/templates/widget/account-selector.html',
    scope: {
      inline: '@',
      disabled: '=ngDisabled',
      required: '=ngRequired'
    },
    link: function (scope, element, attrs, ctrls) {
      scope.multiple = attrs.multiple ? true : false;
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      scope.accounts = (AccountService.getCollection().length > 0) ? AccountService.getCollection() : AccountService.getAll({essential:true}).$object;

      scope.ngModelCtrl.$render = function() {
        scope.value = scope.ngModelCtrl.$modelValue;
      };

      scope.toggleAccount = function(account) {
        if (scope.multiple) {
          var list = scope.ngModelCtrl.$modelValue;
          if (!list) list = [];
          var index = list.indexOf(account.id);
          if (index >= 0) list.splice(index, 1);
          else list.push(account.id);

          if (list.length !== 0) scope.ngModelCtrl.$setViewValue(list);
          else scope.ngModelCtrl.$setViewValue(null);
        }
        else scope.ngModelCtrl.$setViewValue(account.id);
        $rootScope.$broadcast('selector-account:updated', account.id);
      };

      scope.isSelected = function(account) {
        if (scope.multiple) {
          return _.contains(scope.ngModelCtrl.$modelValue, account.id);
        }
        else {
          return (account.id == scope.ngModelCtrl.$modelValue);
        }
      };
    }
  };
};

app.directive('accountSelector', ['AccountService', '$rootScope', AccountSelector]);
